import React from 'react';
import { Apple, Play } from 'lucide-react';

const CTA = () => {
  return (
    <section id="download" className="relative py-24 overflow-hidden bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="relative rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-[#0b2f5c] via-[#124178] to-[#0b2f5c] p-10 md:p-16">
          {/* Decorative background */}
          <div className="absolute -top-24 -right-24 w-80 h-80 bg-sky-400/25 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-sky-500/20 rounded-full blur-3xl" />
          <div className="absolute inset-0 opacity-[0.04]" style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
            backgroundSize: '24px 24px',
          }} />

          <div className="relative grid md:grid-cols-2 gap-10 items-center">
            <div className="text-white">
              <div className="inline-block px-3 py-1 rounded-full bg-white/10 border border-white/20 text-sky-200 text-xs font-semibold tracking-wide uppercase mb-4">
                Ready when you are
              </div>
              <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight mb-4">
                The future of everyday services.
              </h2>
              <p className="text-white/75 leading-relaxed max-w-md">
                Whether it is a ride, a repair, or roadside help — MaLife makes life simpler. Download now and experience true convenience.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4 md:justify-end">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group inline-flex items-center gap-3 bg-white text-[#0b2f5c] px-6 py-4 rounded-2xl shadow-xl hover:-translate-y-0.5 transition-all"
              >
                <Apple className="w-7 h-7" />
                <div className="text-left">
                  <div className="text-[11px] leading-none text-slate-500">Download on the</div>
                  <div className="text-lg font-semibold leading-tight">App Store</div>
                </div>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group inline-flex items-center gap-3 bg-[#0b2f5c] border border-white/30 text-white px-6 py-4 rounded-2xl shadow-xl hover:bg-[#0f3a70] hover:-translate-y-0.5 transition-all"
              >
                <Play className="w-7 h-7 fill-white" />
                <div className="text-left">
                  <div className="text-[11px] leading-none text-white/60">GET IT ON</div>
                  <div className="text-lg font-semibold leading-tight">Google Play</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
